export const config = {
  title: "Todd’s Team Realty | Trusted Real Estate Professionals in Dearborn, MI",
  meta: {
    description:
      "Todd’s Team Realty, based in Dearborn, MI, offers expert real estate services to help you buy or sell homes with confidence and ease.",
    keywords: [
      "Dearborn MI real estate",
      "Todd’s Team Realty",
      "buy home Dearborn",
      "sell home Dearborn",
      "Real Estate One agents"
    ],
    author: "Todd’s Team Realty",
    canonicalUrl: "https://toddsteamrealty.com/",
  },
  sections: {
    header: {
      businessName: "Todd’s Team Realty",
    },
    sectionB: {
      heroTitle: "Todd’s Team Realty",
      heroSubtitle: "Helping You Find the Perfect Home in Dearborn, MI",
      learnAboutText: "Contact Our Team",
      phoneNumber: "5868735595",
      phoneLabel: "(586) 873-5595",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2158963873/photo/aerial-view-of-finance-district-in-london.jpg?s=612x612&w=0&k=20&c=nJi-iIIbMROdHkaO8isPR84Y0WPrq0q8ZQ-ck1lGAxQ=",
      cardData: [
        {
          title: "Buy a Home",
          description: "Find your dream home with help from our experienced agents.",
        },
        {
          title: "Sell a Home",
          description: "Get top dollar for your property with expert market insight.",
        },
        {
          title: "Local Market Experts",
          description: "Serving Dearborn and surrounding Michigan communities.",
        },
      ],
      description:
        "With deep knowledge of the Michigan housing market, Todd’s Team Realty ensures smooth transactions whether you’re buying or selling.",
    },
    sectionC: {
      servicesTitle: "Our Real Estate Services",
      servicesDescription:
        "We specialize in guiding clients through every step of buying and selling homes in Michigan.",
      cards: [
        {
          title: "Home Buying Assistance",
          description: "Helping you find and purchase your dream home stress-free.",
          imageSrc: "https://media.istockphoto.com/id/2197655235/photo/close-up-of-three-people-looking-at-financial-data-with-graphs-and-charts.jpg?s=612x612&w=0&k=20&c=rOX0dS9sbA5EaYkcj-UdjeboXoopcu4-dy6qp0XJy_c=",
          imageAlt: "Buying a home",
        },
        {
          title: "Home Selling Strategy",
          description: "Professional valuation, staging, and listings to get the best value.",
          imageSrc: "https://media.istockphoto.com/id/2155527498/photo/asian-businesswoman-discusses-home-purchase-contracts-with-clients-at-her-desk-focusing-on.jpg?s=612x612&w=0&k=20&c=vSLUrcEeGPlL_P0BFxzMK03Cfcuiaz4Z2R17whH4auI=",
          imageAlt: "Selling a home",
        },
        {
          title: "Relocation Services",
          description: "Support for moving in or out of the Dearborn area.",
          imageSrc: "https://media.istockphoto.com/id/1409298953/photo/real-estate-agents-shake-hands-after-the-signing-of-the-contract-agreement-is-complete.jpg?s=612x612&w=0&k=20&c=SFybbpGMB0wIoI0tJotFqptzAYK_mICVITNdQIXqnyc=",
          imageAlt: "Relocation support",
        },
      ],
      otherServicesTitle: "Why Choose Todd’s Team Realty",
      otherServicesList: [
        "Experienced and friendly agents",
        "Knowledge of the local market",
        "Real Estate One affiliation",
        "Fast communication",
        "Client-first approach",
      ],
    },
    sectionD: {
      aboutTitle: "About Todd’s Team Realty",
      aboutImage: {
        src: "https://media.istockphoto.com/id/2164822692/photo/suburban-sprawl.jpg?s=612x612&w=0&k=20&c=Z1eiTgQPjSVSpTwcNr7gcvIcBX8lMjCHeV_iDxqWONA=",
        alt: "Todd’s Team Realty",
      },
      aboutText: [
        "Todd’s Team Realty is part of Real Estate One, proudly serving the Dearborn, MI area. We are committed to helping families find the perfect home and guiding sellers to close great deals.",
        "From first-time buyers to seasoned investors, we offer personalized service and unmatched support.",
      ],
    },
    sectionE: {
      profileImage: "https://res.cloudinary.com/dq0gbgsdy/image/upload/c_limit,w_180,h_180/uploads/jgg81_etU.png",
      profileAlt: "Todd’s Team Realty Logo",
      businessName: "Todd’s Team Realty",
      contact: {
        phone: "5868735595",
        phoneLabel: "(586) 873-5595",
        email: "toddsteamrealty@gmail.com",
        website: "https://toddsteamrealty.com/",
        address: "22001 Michigan Ave, Dearborn, MI 48124, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "22001 Michigan Ave, Dearborn, MI 48124, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps?q=22001+Michigan+Ave,+Dearborn,+MI+48124&output=embed",
    },
  },
};

export default config;
